import { atom } from "recoil"

// Save selected row ids
export const printedPackagesRowIdsState = atom({
  key: "printedPackagesRowIdsState",
  default: {},
})

// Save old package list
export const printedPackagesState = atom({
  key: "printedPackagesState",
  default: [],
})
